import { render, staticRenderFns } from "./UploadCropper.vue?vue&type=template&id=3d153f83&scoped=true"
import script from "./UploadCropper.vue?vue&type=script&lang=js"
export * from "./UploadCropper.vue?vue&type=script&lang=js"
import style0 from "./UploadCropper.vue?vue&type=style&index=0&id=3d153f83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d153f83",
  null
  
)

export default component.exports